<!-- 社区办理柱状图 -->
<template>
    <div class="nodataBox" v-if="nodata">暂无数据</div>
    <div :id="'echart2'+index" style="width:100%;height:100%" v-else></div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    inject:['isSmallWidth'],
  props:{
    index:{
      type:null,
      default:0,
    },
    token:{
      type:String,
      default: ''
    }
  },
    data() {
    //这里存放数据
        return {
            nodata:false,
            ids:[],//'存储社区id''
            color:['#7ebaff','#ff7d7d'] //柱状图颜色
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            var url = this.urlobj.getCommunityEvent

            this.$get(url,{},{
              token:this.token || this.$store.state.access_token
            }).then(res => {
                if (res.isSucceed) {
                    let data = res.rows[0].xmap
                    if(!data.length){
                        this.nodata = true;
                        return
                    }

                    data.forEach(item => {
                        item.communityName = item.communityName.indexOf('社区')>-1?item.communityName.split('社区')[0]:item.communityName.split('街道')[0]+'街道'
                        item.allCount = item.exeCount+item.unExeCount
                    });

                    data.sort(this.$util.compare('allCount'))
                    if(data.length>5) data=data.slice(0,5)

                    this.ids = data.map(item =>{
                      return item.communityId
                    })
                    var ecdata = {
                      legend:res.rows[0].legend,
                      label:data.map(item=>item.communityName),
                      exeCount:data.map(item=>item.exeCount),
                      unExeCount:data.map(item=>item.unExeCount)
                    }
                    if (!this.token) {
                      this.initEcharts(ecdata)
                    }else {
                      this.initCongtaiEcharts(ecdata)
                    }


                } else {

                }
            }).catch(e => {

            })
        },
        initEcharts (ecdata) {
            console.log(ecdata)
          var id = 'echart2'+this.index
            var echart = echarts.init(document.getElementById(id));
            let option={
                color:this.color,
                tooltip : {
                    trigger: 'item',
                    axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                    type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
                    }
                },
                legend: {
                    data:ecdata.legend,
                    textStyle:{    //图例文字的样式
                            color:'#91b1fc',  //文字颜色
                            fontSize:12
                        },
                    itemHeight:10,
                    itemWidth:10,
                },
                grid: {
                    left: 15,
                    right: '4%',
                    bottom: '3%',
                    top:30,
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        data:ecdata.label,
                        axisLabel:{
                            color:'#b0b0b0',
                            fontSize:12,
                            formatter: (value=>{
                                return this.$util.autoSplit(value)
                            }),
                        },
                        splitLine:{show: false},//去除网格线
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        axisLabel:{
                            color:'#b0b0b0',
                            fontSize:12
                        },
                        splitLine:{
                            lineStyle:{
                                color:'#283071'
                            }
                        },//去除网格线
                        splitNumber:this.isSmallWidth?3:5
                    }
                ],
                series : [
                    {
                        name:ecdata.legend[0],
                        type:'bar',
                        stack:'社区办理',
                        data:ecdata.exeCount,
                        barWidth:18,
                    },
                    {
                        name:ecdata.legend[1],
                        type:'bar',
                        stack:'社区办理',
                        data:ecdata.unExeCount,
                        barWidth:18,
                    },

                ]
            }
            console.log(option)
            echart.setOption(option)
            echart.on('click', (params)=>{
                console.log(params)
                console.log(params.seriesIndex);
                console.log(params.dataIndex);
                this.getEventList(params.dataIndex,params.seriesIndex)
            });
        },
      initCongtaiEcharts (ecdata) {
        var id = 'echart2'+this.index
        var echart = echarts.init(document.getElementById(id));
        let option={
          color:this.color,
          tooltip : {
            trigger: 'item',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
            }
          },
          legend: {
            data:ecdata.legend,
            textStyle:{    //图例文字的样式
              color:'#91b1fc',  //文字颜色
              fontSize:16
            },
            icon:'rect',
            itemHeight:10,
            itemWidth:10,
          },
          grid: {
            left: 15,
            right: '4%',
            bottom: '3%',
            top:30,
            containLabel: true
          },
          xAxis : [
            {
              type : 'category',
              data:ecdata.label,
              axisLabel:{
                color:'#b0b0b0',
                fontSize:12,
                formatter: (value=>{
                  return this.$util.autoSplit(value)
                }),
              },
              splitLine:{show: false},//去除网格线
              axisLine:{
                lineStyle:{
                  color:'#283071'
                }
              },
              axisTick:{
                show:false,
              }
            }
          ],
          yAxis : [
            {
              type : 'value',
              axisLabel:{
                color:'#b0b0b0',
                fontSize:12
              },
              splitLine:{
                lineStyle:{
                  color:'#283071'
                }
              },
              axisLine:{
                show:false
              },
              splitNumber:this.isSmallWidth?3:5
            }
          ],
          series : [
            {
              name:ecdata.legend[0],
              type:'bar',
              stack:'社区办理',
              data:ecdata.exeCount,
              barWidth:40,
            },
            {
              name:ecdata.legend[1],
              type:'bar',
              stack:'社区办理',
              data:ecdata.unExeCount,
              barWidth:40,
            },

          ]
        }
        console.log(option)
        echart.setOption(option)
        echart.on('click', (params)=>{
          console.log(params)
          console.log(params.seriesIndex);
          console.log(params.dataIndex);
          this.getEventList(params.dataIndex,params.seriesIndex)
        });
      },
        getEventList(dataIndex,seriesIndex){
            let url = this.urlobj.getPeopleEventList;
            this.$get(url, {
                communityId:this.ids[dataIndex],
                eventsType:seriesIndex?0:1,
                page:1,
                rows:1000,
            })
            .then(res => {
                if (res.rows.length) {
                    /* 初始化数据 */
                   let returndata = {
                       color:this.color[seriesIndex],
                       list:res.rows.filter(item => item.event && item.event.location).map(item=>{
                           return {
                              //id:item.id,
                              name:item.event.content,
                              position:item.event.location,
                              opacity:(Math.random()+0.3).toFixed(1),
                           }
                       })
                   }

                   this.$emit('setMarkers',returndata)
                } else {
                }
            })
            .catch(e => {
                console.log(e);
            });
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.nodataBox{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #b0b0b0;
    height: 100%;
}
</style>
